export const CHAVE_CONSENTIMENTO = 'fatcat_consentimento_cookies';

// 'aceito' | 'recusado' | null (sem escolha, localStorage indisponível ou valor inválido)
export const lerConsentimento = () => {
  try {
    const valor = window.localStorage.getItem(CHAVE_CONSENTIMENTO);
    return valor === 'aceito' || valor === 'recusado' ? valor : null;
  } catch (e) {
    return null;
  }
};

export const salvarConsentimento = (valor) => {
  try {
    window.localStorage.setItem(CHAVE_CONSENTIMENTO, valor);
  } catch (e) {
    // sem storage: a escolha vale só nesta sessão
  }
};

export const consentimentoAceito = () => lerConsentimento() === 'aceito';
